export default "__VITE_ASSET__BIcARA$G__"